import { Navigate } from 'react-router-dom';

const RegisterPage = () => <Navigate to="/auth/login" replace />;

export default RegisterPage;
